// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_16YBX","cardTitle":"_5FsPl","cardItem":"o9vNf","cardItemTitle":"_3PyDq","cardItemValue":"_3zIHr"};